import moment from 'moment'
import React from 'react'
import { render } from 'react-dom'
import { LOGIN_URL, PREMIUM_URL } from '@bikemap/js/settings'
import { TranslationProvider } from '@bikemap/components/_translation'
import gettext from '@bikemap/js/services/gettext'
import sessionData from '@bikemap/js/services/sessionData'
import userService from '@bikemap/js/services/user'
import { InviteWidget } from '@bikemap/components/InviteWidget'

/**
 * Fetch user data and format it for InviteWidget component.
 * @return {Promise<import('@bikemap/components/InviteWidget/InviteWidget').InviteWidgetPropsType>}
 */
export async function getInviteWidgetOptions() {
    const isLoggedIn = await sessionData.isLoggedIn()

    /** @type {import('@bikemap/components/InviteWidget/InviteWidget').InviteWidgetPropsType} */
    const options = {
        loggedIn: isLoggedIn,
        loginHref: LOGIN_URL,
        subscribeHref: PREMIUM_URL,
    }

    if (isLoggedIn) {
        const user = await userService.getEntity()
        if (user) {
            options.userAvatar = user.avatar
            options.inviteLink = user.referralCodeLink
            options.premiumType = (user.isPremium && !user.isReferralPremium) ? 'subscribed' : undefined

            const loopEnd = user.referralRewardsLoop.freePremiumExpirationDate
            const loopMax = user.referralRewardsLoop.maxLoopDuration

            if (user.isReferralPremium && loopEnd && moment(loopEnd).isAfter() && loopMax) {
                options.premiumType = 'free'
                options.daysLeft = Math.max(moment(loopEnd).diff(moment(), 'days'), 0)
                options.maxDaysLeft = loopMax
            }
        }
    }

    return options
}

/**
 * Get title based on provided widget options.
 * @param {import('@bikemap/components/InviteWidget/InviteWidget').InviteWidgetPropsType} options
 * @returns {string} HTML with new title
 */
export function getInviteWidgetTitle(options) {
    if (options.premiumType === 'free') {
        return '<strong>' + gettext('Premium Loop') + '</strong>'
    }
    if (options.premiumType === 'subscribed') {
        return '<strong>' + gettext('Refer a Friend') + '</strong>'
    }
    return gettext('Refer a Friend') + ', <strong>' + gettext('earn Premium') + '</strong>'
}

/**
 * Initialize InviteWidget component.
 * @param {string} elementId ID of element where to render InviteWidget component
 * @param {import('@bikemap/components/InviteWidget/InviteWidget').InviteWidgetPropsType} options
 */
export default function initInviteWidget(elementId, options) {
    const el = document.getElementById(elementId)
    if (!el) {
        return false
    }

    options.facebookHref = el.getAttribute('data-facebook-href') || ''
    options.twitterHref = el.getAttribute('data-twitter-href') || ''

    render((
        <TranslationProvider translate={gettext}>
            <InviteWidget {...options}/>
        </TranslationProvider>
    ), el)
}
